export const VERSION = '1.3.1';
export const PASSWORD_SECURITY = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/;
export const PASSWORD_MIN_LENGTH = 7;
export const TEE_TIME_MAX_PLAYERS = 4;
export const DOCUMENT_MAX_FILES = 10;
export const DOCUMENT_MAX_SIZE = 20971520; // 20 Mo
export const DOCUMENT_TYPES = [
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/zip',
  'image/*',
];

// export const API_BASE_URI = global.apiBasePath;
// export const ORIGIN = global.origin;
// export const BOOKER = global.booker;

export const HELP_URL = 'https://sites.google.com/primagolf.fr/aide-primaweb';

/* */
export const DEFAULT_GOLF_OPTS = {
  activities: {},
  paymentMethods: {
    member: [0],
    visitor: [0],
  },
  wording: {
    membership: 2,
    member: 2,
  },
  booking: {
    forOthers: false,
    showOthersOnTimeslot: false,
    showAvailabilityOnTimeslot: false,
    maxNumberOfPlayers: TEE_TIME_MAX_PLAYERS, // DEPRECATED
  },
};

// Constantes pour la gestion du cache des activités et créneaux
export const CACHE_TIMES = {
  ACTIVITIES: {
    STALE_TIME: 5 * 60 * 1000, // 5 minutes
    CACHE_TIME: 30 * 60 * 1000, // 30 minutes
    RETRY: 3,
  },
  SLOTS: {
    STALE_TIME: 2 * 60 * 1000, // 2 minutes
    CACHE_TIME: 10 * 60 * 1000, // 10 minutes
  },
};

export const activityActions = {
  SET_ACTIVITY: 'SET_ACTIVITY',
  SET_SELECTED_ACTIVITY: 'SET_SELECTED_ACTIVITY',
  SET_ACTIVE_OPTION: 'SET_ACTIVE_OPTION',
  SET_SELECTED_DURATION: 'SET_SELECTED_DURATION',
  SET_SHOW_DISPONIBILITIES: 'SET_SHOW_DISPONIBILITIES',
  SET_COURSE: 'SET_COURSE',
  SET_TYPES: 'SET_TYPES',
  SET_TYPES_FILTERS: 'SET_TYPES_FILTERS',
  SET_ERROR: 'SET_ERROR',
  RESET_STATE: 'RESET_STATE',
};
